﻿import { defineComponent } from 'vue';

import passenger from "./passenger.vue";

export default defineComponent({
    components: {
        passenger
    },
    props: {
    },
    data() {
    },
    methods: {
    },
    mounted() {
    }
});